package tech.gensert.portal.common.model

import kotlinx.serialization.Serializable

@Serializable
actual data class CheckoutPaymentUrl(
    actual var url: String
)